import { render, staticRenderFns } from "./content.vue?vue&type=template&id=1fa0624f"
import script from "./content.js?vue&type=script&lang=js&external"
export * from "./content.js?vue&type=script&lang=js&external"
import style0 from "./content.vue?vue&type=style&index=0&id=1fa0624f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports